import { AnyAction } from "redux";
import { IFilterOptions } from "../../types/filters.types";
import { IRetailAdjustment } from "../../types/retailAdjustments.types";

export const GET_RETAIL_ADJUSTMENTS_DATA = "GET_RETAIL_ADJUSTMENTS_DATA";
export const GET_RETAIL_ADJUSTMENTS_DATA_SUCCESS =
  "GET_RETAIL_ADJUSTMENTS_DATA_SUCCESS";
export const GET_RETAIL_ADJUSTMENTS_DATA_ERROR =
  "GET_RETAIL_ADJUSTMENTS_DATA_ERROR";

export interface IRetailAdjustmentsReducer {
  isLoadingRetailAdjustmentsData: boolean;
  retailAdjustmentsData: IRetailAdjustment[];
}

export const fetchRetailAdjustmentsData = (filters: IFilterOptions) => ({
  type: GET_RETAIL_ADJUSTMENTS_DATA,
  value: {
    filters,
  },
});

export const fetchRetailAdjustmentsDataSuccess = (
  data: IRetailAdjustment[],
) => ({
  type: GET_RETAIL_ADJUSTMENTS_DATA_SUCCESS,
  value: {
    data,
  },
});

export const fetchRetailAdjustmentsDataError = () => ({
  type: GET_RETAIL_ADJUSTMENTS_DATA_ERROR,
});

export const initialState: IRetailAdjustmentsReducer = {
  isLoadingRetailAdjustmentsData: false,
  retailAdjustmentsData: [],
};

export const retailAdjustmentsReducer = (
  state = initialState,
  action: AnyAction,
) => {
  switch (action.type) {
    case GET_RETAIL_ADJUSTMENTS_DATA:
      return {
        ...state,
        isLoadingRetailAdjustmentsData: true,
        retailAdjustmentsData: [],
      };
    case GET_RETAIL_ADJUSTMENTS_DATA_SUCCESS:
      return {
        ...state,
        isLoadingRetailAdjustmentsData: false,
        retailAdjustmentsData: action.value.data,
      };
    case GET_RETAIL_ADJUSTMENTS_DATA_ERROR:
      return {
        ...state,
        isLoadingRetailAdjustmentsData: false,
      };
    default:
      return state;
  }
};

export default retailAdjustmentsReducer;
